import React from "react";
import { Input, TextField } from "@mui/material";

const SearchBar = ({ searchKeyword, handleSearch }) => {
  return (
    
    <TextField
      label="Search"
      type="text"
      variant="standard"
      value={searchKeyword}
      onChange={handleSearch}
      placeholder=" Search..."
      size="small"
  
    />
  
  );
};

export default SearchBar;
